import React from 'react';
import Loader from '../../common/Loader';
import MessageInfo from '../../common/MessageInfo';
import { useFetchBetBuilderMatchBets } from '../../data/useFetchBetBuilderMatchBets';
import BetBuilderMatch from './BetBuilderMatch';
import { getLabel } from '../../InitData';
function BetBuilderMatchContainer(props) {
	const [response] = useFetchBetBuilderMatchBets(props.betBuilderMatch, !props.betBuilderMatch.openChooseSection, false);	
	const betBuilderMatch = response.data?.match;
	const betsData = response.data?.betsData;
	
    return <>
	    {
	    	props.betBuilderMatch.openChooseSection && 
	    	<MessageInfo isAdvice={true} message={getLabel('betbuilder.choose_event')} />
	    }
	    {
	    	!response.data && <Loader isError={response.isError} />
	    }
	    {
	    	/*I'm specifing this "key" 'cause if I did not, 
	    	  then the next match will be rendered with the same aggregate id of the previous one. 
	    	  The aggregate state (inside BetBuilderMathc) should be different because it is a new component, 
	    	  but it does not work. I specify the key value to force the virtual dom to get the component replacing */
	    	betsData && <BetBuilderMatch key={betBuilderMatch.pal + "_" + betBuilderMatch.avv} betBuilderMatch={betBuilderMatch} betsData={betsData}   />
	    }
    </>
}
            
export default BetBuilderMatchContainer;